<template>

  <Modal v-if="visible" :value="value" @input="closeModal">
    <p slot="header">Nova Tag</p>

    <Form :customField="customField" @cancel="closeModal" @savedCustomField="$emit('savedCustomField')"/>

  </Modal>

</template>

<script>
import Modal from '@/components/shares/specialTag/Modal'
import Form from '@/components/custom_fields/Form'

export default {
  components: { Form, Modal },
  computed: {
    visible() {
      return this.value
    }
  },
  data: () => ({ }),
  methods: {
    closeModal() {
      this.$emit('input', false)
    },
  },
  name: 'CustomFieldModal',
  props: {
    value: { default: false, type: Boolean },
    customField: { type: Object, required: false }
  },
}
</script>

<style scoped>
</style>
